module.exports = __webpack_public_path__ + "img/Germany.702f527f.svg";